import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
  ghl: null,
  calendly: null,
  oncehub: null,
  elevenlabs: null,
  loading: false,
  error: null,
};

const useIntegrationsStore = create(
  devtools(
    (set) => ({
      ...initialState,
      setGhl: (ghl) => set({ ghl }),
      setCalendly: (calendly) => set({ calendly }),
      setOncehub: (oncehub) => set({ oncehub }),
      setElevenlabs: (elevenlabs) => set({ elevenlabs }),
      setCalendlyEventTypeUri: (eventTypeUri) =>
        set((state) => ({
          calendly: {
            ...state.calendly,
            current_event_type_uri: eventTypeUri,
          },
        })),
      setGhlCalendarId: (calendarId) =>
        set((state) => ({
          ghl: {
            ...state.ghl,
            current_calendar_id: calendarId,
          },
        })),
      setLoading: (loading) => set({ loading }),
      setError: (error) => set({ error }),
      setIntegrations: (integrations) =>
        set({
          ghl: integrations.ghl || null,
          calendly: integrations.calendly || null,
          oncehub: integrations.oncehub || null,
          elevenlabs: integrations.elevenlabs || null,
        }),
      reset: () => set({ ...initialState }),
    }),
    { name: 'IntegrationsStore' }
  )
);

export default useIntegrationsStore;
